import ResultsVM from './results-vm';
import Vue from 'vue';
export default {
  init : function(element) {
    console.log('Kadenze.SearchResults initialization function called');
    let vm = new Vue(ResultsVM);
    vm.bindData(JSON.parse(element.dataset.resultsJson));
    vm.$mount(element);
  }
};
